<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Bulk Run Confirmation</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>

<div class="modal-body" hsDraggable="modal-dialog">
  <p>This will create {{numberOfRuns.toString()}} recon worker runs.</p>
  <div class="d-flex">
    <p>Please type the number of runs to confirm.</p>
    <input
      type="number"
      class="confirmationInput"
      [(ngModel)]="confirmationInput"
      (ngModelChange)="onConfirmationInputChange()"
    />
  </div>
</div>

<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()">Cancel</button>
    <button
      nf-button="save"
      [disabled]="isSaveDisabled"
      (click)="activeModal.close(true)"
    >
      Run Accounts
    </button>
  </div>
</div>
